export type InstrumentCategory = 'crypto' | 'stock' | 'index' | 'currency' | 'commodity';

const CATEGORY_LABELS: Record<InstrumentCategory, string> = {
  crypto: 'Crypto',
  stock: 'Stock',
  index: 'Index',
  currency: 'Currency',
  commodity: 'Commodity',
};

export function normalizeCategory(value: string | null | undefined): string {
  return value?.trim().toLowerCase() ?? '';
}

export function renderCategoryLabel(value: string | null | undefined): string {
  const category = normalizeCategory(value) as InstrumentCategory;
  return CATEGORY_LABELS[category] ?? category.toUpperCase();
}

export function hasCategory(value: string | null | undefined): boolean {
  return normalizeCategory(value).length > 0;
}

/** Prefer the non-crypto leg when pairing two exchanges (mirrors server merge logic). */
export function mergePairCategory(
  a: string | null | undefined,
  b: string | null | undefined,
): string {
  const catA = normalizeCategory(a);
  const catB = normalizeCategory(b);
  if (catA && catA !== 'crypto') return catA;
  if (catB && catB !== 'crypto') return catB;
  return catA || catB;
}

const CATEGORY_BADGE_CLASS: Record<InstrumentCategory, string> = {
  crypto: 'opp-top-symbol-type-badge--crypto',
  stock: 'opp-top-symbol-type-badge--stock',
  index: 'opp-top-symbol-type-badge--index',
  currency: 'opp-top-symbol-type-badge--currency',
  commodity: 'opp-top-symbol-type-badge--commodity',
};

export function categoryBadgeClass(value: string | null | undefined): string {
  const category = normalizeCategory(value) as InstrumentCategory;
  const modifier = CATEGORY_BADGE_CLASS[category];
  return modifier
    ? `opp-top-symbol-type-badge ${modifier}`
    : 'opp-top-symbol-type-badge opp-top-symbol-type-badge--unknown';
}
